<template>
  <div>
    <input-select :fieldData="fieldData" />
  </div>
</template>

<script>
import InputSelect from '../../interactive/InputSelect';

export default {
  components: { InputSelect },
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['selectOptions', 'agencyIntegrations', 'agencyState'],
  data() {
    return {
      fieldData: {
        field_value: null, // Initialized as blank string '' so the watcher won't trigger from undefined to blank string
      },
    };
  },
  computed: {
    fieldName() {
      return `name_
        ${this.agencyIntegrations.carrierId}_
        ${this.agencyIntegrations.productId}_
        ${this.agencyIntegrations.vendorId}_
        ${this.agencyIntegrations.agencyId}_
        ${this.agencyState.stateCd}`;
    },
    fieldLabel() {
      return `${this.agencyState.stateName} (${this.agencyState.stateCd})`;
    },
    isEnabled() {
      return this.agencyState.isActive;
    },
    selectedOption() {
      // window.console.info('in computed selectedOption');
      return this.agencyState.currentIntegrationPlatform ? this.agencyState.currentIntegrationPlatform.integrationId : null;
    },
    defaultTextValue() {
      return 'Select one';
    },
    fieldValues() {
      return this.selectOptions;
    },
  },
  methods: {
    // The InputSelect only accepts the common `fieldData` object. This Carrier Manager flow, though, uses a different object structure.
    setFieldData() {
      this.fieldData = {
        label: this.fieldLabel,
        field_type: 'select',
        field_name: this.fieldName,
        is_required: false,
        field_value: this.selectedOption,
        field_validation_rules: '',
        is_enabled: this.isEnabled,
        visible: true,
        max_length: 50,
        values: this.fieldValues,
      };
    },
  },
  mounted() {
    this.setFieldData();
  },
  watch: {
    // Updates parent property since no two-way binding in Vue and the parent object can't be passed to the this component.
    'fieldData.field_value': function fieldDataFieldValue(newValue, oldValue) {
      if (oldValue === null) return;

      const fieldValue = (newValue !== '' ? newValue : -1); // Blank string saved as -1

      const index = this.agencyIntegrations.stateIntegrations.findIndex(state => state.stateCd === this.agencyState.stateCd);

      if (index !== -1) {
        this.agencyIntegrations.stateIntegrations[index].integrationId = fieldValue;
      } else {
        this.agencyIntegrations.stateIntegrations.push({
          stateCd: this.agencyState.stateCd,
          integrationId: fieldValue,
        });
      }
    },
    // // Updates select values once the API returns the values
    // selectOptions: function selectOptions(newValue, oldValue) {
    //   // window.console.info('NEW SELECTOPTIONS', newValue, oldValue, this.agencyState.stateCd);
    //   this.fieldData.values = newValue;
    // },
    // // Updates select values once the API returns the values
    // agencyState: function agencyState(newValue, oldValue) {
    //   if (newValue.stateCd === 'AZ') {
    //     window.console.info('NEW agencyState', newValue, oldValue, this.selectedOption, newValue.currentIntegrationPlatform.integrationId);
    //   } else {
    //     window.console.info('nope!');
    //   }
    //   this.fieldData.is_enabled = this.isEnabled;
    //   // this.fieldData.values = newValue.;
    //   this.fieldData.field_value = this.selectedOption;

    // },
  },
};
</script>

<style scoped lang="scss">
.input-elements {
  >>> .field-input-text {
    .input-group {
      width: 100% !important;
    }

    label {
      display: none;
    }
  }

  >>> .form-group {
    margin-bottom: 0;
  }

  &.read-only-id label {
    font-weight: normal;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/admin/carriers/agencyIntegration/AgencyState.vue?1c9b32d2